export default {
  parts: [
    'wrapper',
    'row',
    'step',
    'stepLast',
    'circle',
    'label',
    'connector',
    'stateColors',
  ],
  baseStyle: {
    wrapper: {
      w: '100%',
      overflow: 'visible',
      px: 10,
    },
    row: {
      align: 'center',
      w: '100%',
      pb: '44px',
      overflow: 'visible',
    },
    step: {
      align: 'flex-start',
      flex: '1 1 0',
      minW: '48px',
    },
    stepLast: {
      align: 'flex-start',
      flex: '0 0 auto',
      minW: '32px',
    },
    circle: {
      w: '32px',
      h: '32px',
      borderRadius: 'full',
      borderWidth: '2px',
      borderStyle: 'solid',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    label: {
      position: 'absolute',
      top: 'calc(100% + 8px)',
      left: '50%',
      transform: 'translateX(-50%)',
      w: '110px',
      px: 1,
      textAlign: 'center',
      fontSize: 'xs',
      color: 'progressBar.label',
    },
    connector: {
      flex: '1',
      h: '2px',
      bg: 'progressBar.track',
      mt: '15px',
      minW: '16px',
    },
    stateColors: {
      completed: 'progressBar.stateCompleted',
      active: 'progressBar.stateActive',
      pending: 'progressBar.statePending',
      disabled: 'progressBar.stateDisabled',
    },
  },
  variants: {
    /* gray: {
      stateColors: {
        completed: 'gray.600',
        active: 'gray.400',
        pending: 'gray.300',
        disabled: 'gray.200',
      },
    }, */
  },
};
